import { User, Award, FileText } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const PLACEHOLDERS = [
  { icon: User, type: "EXECUTOR STORY" },
  { icon: Award, type: "FUNDED ACCOUNT MILESTONE" },
  { icon: FileText, type: "P.E.E. OS CASE STUDY" },
];

const CATEGORIES = [
  "EXECUTOR STORY",
  "FUNDED ACCOUNT MILESTONE",
  "EXECUTION BREAKTHROUGH",
  "P.E.E. OS CASE STUDY",
  "GAME PLAN DEVELOPMENT",
  "DISCIPLINE MILESTONE",
];

export default function ResultsV2() {
  return (
    <section id="results" data-testid="results-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="10 — Results"
          testid="results-heading"
          title={
            <>
              Real Executors.
              <br />
              Real <span className="glow-text-neon text-neon">progress.</span>
            </>
          }
          description="Progress in trading isn't measured only by one winning trade. We look for evidence of better decisions, stronger discipline, improved execution, funded milestones, process consistency, and meaningful development over time. Member stories and case studies are published only when verified and shared with permission."
        />

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {CATEGORIES.map((c) => (
              <span
                key={c}
                className="rounded-full border border-line px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-mist"
              >
                {c}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PLACEHOLDERS.map((p, i) => (
            <Reveal key={p.type} delay={0.07 * i} className="h-full">
              <div
                data-testid={`results-placeholder-${i}`}
                className="flex h-full min-h-[220px] flex-col rounded-lg border border-dashed border-line bg-charcoal/50 p-7"
              >
                <div className="flex items-center justify-between">
                  <p.icon size={20} className="text-dim" />
                  <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-dim">
                    {p.type}
                  </span>
                </div>
                <div className="flex flex-1 flex-col items-center justify-center py-8 text-center">
                  <span className="font-display text-lg font-bold uppercase tracking-tight text-white/35">
                    Real Executor Story
                  </span>
                  <span className="mt-3 rounded border border-neon/40 bg-neon/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neon">
                    Coming Soon
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 border-t border-line pt-10">
            <p className="font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-white sm:text-2xl">
              No fabricated screenshots. No invented numbers.{" "}
              <span className="text-neon">No guaranteed results.</span>
            </p>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-dim">
              Real people. Real experiences. Shared with permission.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
